import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("product", ["product", "coupon"]),
    ...mapState("user", ["myCoproducers"]),
    productRoutes() {
      return {
        product: {
          name: "product",
          title: "Meus produtos"
        },
        "coproducer-product-links": {
          name: "coproducer-product-links",
          title: (() => {
            const productName = this.myCoproducers.find(
              coproducer => coproducer.product?.id == this.$route.params.id
            )?.product?.name;
            return productName
              ? productName + " - Links de divulgação"
              : "Links de divulgação";
          })(),
          params: { id: this.$route.params.id }
        },

        // "product-new": {
        //   title: "Novo produto",
        //   name: "product-new"
        // },
        // "product-new-event": {
        //   name: "product-new-event",
        //   title: "Ingressos para eventos presenciais"
        // },
        // "product-new-online-course": {
        //   name: "product-new-online-course",
        //   title: "Curso online"
        // },
        // "product-new-signature": {
        //   name: "product-new-signature",
        //   title: "Assinatura"
        // },
        product: {
          name: "product",
          title: "Meus produtos"
        },
        "product-details": {
          name: "product-details",
          title: this.product?.name || "...",
          params: { id: this.$route.params.id }
        },
        "product-basic-info": {
          name: "product-basic-info",
          title: "Informações básicas",
          params: { id: this.$route.params.id }
        },
        "product-coproducers": {
          name: "product-coproducers",
          title: "Coproduções",
          params: { id: this.$route.params.id }
        },
        "product-links": {
          name: "product-links",
          title: "Links de divulgação",
          params: { id: this.$route.params.id }
        },
        "product-oneclickbuy": {
          name: "product-oneclickbuy",
          title: "Link one click buy",
          params: { id: this.$route.params.id }
        },
        "product-prices": {
          name: "product-prices",
          title: "Precificação e ofertas",
          params: { id: this.$route.params.id }
        },
        "product-plans": {
          name: "product-plans",
          title: "Precificação e planos",
          params: { id: this.$route.params.id }
        },
        "product-analytics": {
          name: "product-analytics",
          title: "Api de conversões",
          params: { id: this.$route.params.id }
        },
        "product-edit-pixel": {
          name: "product-edit-pixel",
          title: "Pixel de Rastreamento",
          params: { id: this.$route.params.id }
        },
        "product-facebook-pixel": {
          name: "product-facebook-pixel",
          title: "Píxel do Facebook",
          params: { id: this.$route.params.id }
        },
        "product-google-analytics": {
          name: "product-google-analytics",
          title: "Google Analytics",
          params: { id: this.$route.params.id }
        },

        "product-prices": {
          name: "product-prices",
          title: "Precificação e ofertas",
          params: { id: this.$route.params.id }
        },
        "product-prices-new": {
          name: "product-prices-new",
          title: "Nova Oferta",
          params: { id: this.$route.params.id }
        },
        "product-prices-main": {
          name: "product-prices-main",
          title: "Oferta Principal",
          params: { id: this.$route.params.id }
        },
        "product-prices-edit": {
          name: "product-prices-edit",
          title: "Editar Oferta",
          params: { id: this.$route.params.id }
        },

        // EVENTOS
        "event-lots": {
          name: "event-lots",
          title: "Ingressos",
          params: { id: this.$route.params.id }
        },
        "event-new-lot": {
          name: "event-new-lot",
          title: "Novo ingresso",
          params: { id: this.$route.params.id }
        },
        "event-edit-lot": {
          name: "event-edit-lot",
          title: this.lot?.name || "Editar ingresso",
          params: {
            id: this.$route.params.id,
            lot_code: this.$route.params.lot_code
          }
        },
        "event-participants": {
          name: "event-participants",
          title: "Participantes",
          params: { id: this.$route.params.id }
        },

        // CUPOM
        "product-coupons": {
          name: "product-coupons",
          title: "Cupons",
          params: { id: this.$route.params.id }
        },
        "product-new-coupon": {
          name: "product-new-coupon",
          title: "Novo cupom",
          params: { id: this.$route.params.id }
        },
        "product-edit-coupon": {
          name: "product-edit-coupon",
          title: "Editar cupom",
          params: {
            id: this.$route.params.id,
            coupon_id: this.$route.params.coupon_id
          }
        },

        // CHECKOUT
        "product-checkout": {
          name: "product-checkout",
          title: "Configurar Checkout",
          params: { id: this.$route.params.id }
        },

        // ALUNOS
        "product-member-area-students": {
          name: "product-member-area-students",
          title: "Alunos",
          params: { id: this.$route.params.id }
        },

        // TURMAS
        "product-member-area-groups": {
          name: "product-member-area-groups",
          title: "Turmas",
          params: { id: this.$route.params.id }
        },
        "product-member-area-groups-add": {
          name: "product-member-area-groups-add",
          title: "Adicionar Turma",
          params: { id: this.$route.params.id }
        },
        "product-member-area-groups-edit": {
          name: "product-member-area-groups-edit",
          title: "Editar Turma",
          params: {
            id: this.$route.params.id,
            group: this.$route.params.group
          }
        },

        // COMENTÁRIOS
        "product-member-area-comments": {
          name: "product-member-area-comments",
          title: "Comentários",
          params: { id: this.$route.params.id }
        }
      };
    }
  }
};
